import { INeighborhood } from "./types";


export default class Neighborhood implements INeighborhood {

  city: string;
  municipality: string;
  neighborhood: string;


  constructor(city: string, municipality: string, neighborhood: string) {
    this.city = city;
    this.municipality = municipality;
    this.neighborhood = neighborhood;
  }

}
